import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink } from "@sagot/ui";
import { useWorkspaceContext } from "../../../session/workspace-context";
import { useDefaultByKey } from "../workflows/defaults/default-note";

/** `routed_by` of a handoff a default workflow placed: `workflow:<system key>`. */
const WORKFLOW_SOURCE = "workflow:";

/** The catalogue key of the default workflow that routed the handoff, or `null` for any other source (topic, default team, fallback ...). */
export const routedByKey = (source: string): string | null => (source.startsWith(WORKFLOW_SOURCE) ? source.slice(WORKFLOW_SOURCE.length) || null : null);

function Name({ systemKey }: { systemKey: string }) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  const { workflow, canView } = useDefaultByKey(systemKey);
  if (!workflow) return <>{t("engage.workflows.defaults.cross.routedByDefault")}</>;
  if (!canView) return <>{workflow.name}</>;
  return <AppLink className="text-primary-ink underline-offset-2 hover:underline" href={consoleRoutes.workflow(summary.slug, workflow.id)}>{workflow.name}</AppLink>;
}

/** "Routed by: {workflow name}" on the handoff card, when a default workflow chose the assignee; nothing for any other route. */
export function RoutedBy({ source }: { source: string }) {
  const { t } = useTranslation();
  const key = routedByKey(source);
  if (!key) return null;
  return (
    <div>
      <dt className="text-fg-subtle">{t("engage.workflows.defaults.cross.routedBy")}</dt>
      <dd className="font-semibold" data-testid="handoff-routed-by"><Name systemKey={key} /></dd>
    </div>
  );
}
